import React from "react";
import { NavLink } from "react-router-dom";
import { sideBarLinks } from "../utils/constants";
import { reactIcons } from "../utils/icons";

const PublicSidebar = ({ isOpen, setIsOpen, isVerify, getToken }) => {
  return (
    <div className="bg-common h-full flex flex-col justify-between overflow-hidden w-full pt-4">
      <div
        className={`pr-1 pl-[17px] flex ${
          !isOpen
            ? "justify-end transition-all duration-75"
            : "justify-start transition-all duration-75"
        }`}
      >
        <button
          onClick={() => {
            if (!isOpen) setIsOpen(true);
            else setIsOpen(false);
          }}
          className="w-10 h-10 flex-center text-white bg-common rounded-full text-3xl hidden lg:flex"
        >
          {!isOpen ? reactIcons.arrowright : reactIcons.arrowleft}
        </button>
      </div>
      <div className="flex flex-col gap-1 mt-4 flex-1 pl-2">
        {sideBarLinks.map((item, index) => {
          return (
            <NavLink
              key={index}
              to={item.path}
              end
              className={({ isActive }) =>
                `relative py-3 w-full px-4 flex gap-4 items-center cursor-pointer duration-100 rounded-l-md ml-2 ${
                  isActive
                    ? "bg-[#FFE3E3] text-[#000000]"
                    : "text-white hover:bg-[#FFE3E3] hover:text-[#000000]"
                }`
              }
            >
              <span className="text-xl">{item.icon}</span>
              {!isOpen && (
                <span className="text-[14px] xl:text-[16px]">{item.title}</span>
              )}
            </NavLink>
          );
        })}
        <NavLink
          to={"/tokens-scan"}
          end
          className={`relative py-3 w-full flex md:hidden px-4  gap-4 items-center cursor-pointer duration-100 rounded-l-md ml-2 ${
            window.location.pathname == "/tokens-scan"
              ? "bg-[#FFE3E3] text-[#000000]"
              : "text-white hover:bg-[#FFE3E3] hover:text-[#000000]"
          }`}
        >
          <span className="text-xl">{reactIcons.ioScan}</span>
          <span className="text-[14px] xl:text-[16px]">MST Scan</span>
        </NavLink>
      </div>
    </div>
  );
};

export default PublicSidebar;
